<div class="message d-flex" [ngClass]="[type ?? '', size ?? '']">
  @if (type === 'warning') {
    <lib-icon class="type-icon" name="alert-triangle"></lib-icon>
  }
  <span class="message-text" [ngClass]="[type ?? '']">
    @if (title) {
      <strong class="message-title">{{ title }} </strong>
    }
    {{ message }}<ng-content></ng-content
  ></span>

  @if (showCloseButton) {
    <button
      vinnova-button-text
      class="p-0 ms-auto close-button"
      (click)="closeButton.emit()"
      [attr.aria-label]="closeLabel"
    >
      <lib-icon name="x"></lib-icon>
    </button>
  }
</div>
